var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColdPlungeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23 12-1.707.931a2.725 2.725 0 0 1-3.393-.652v0a2.708 2.708 0 0 0-3.99-.188v0a2.7 2.7 0 0 1-3.82 0v0a2.708 2.708 0 0 0-3.99.188v0a2.725 2.725 0 0 1-3.393.652L1 12m22 5-1.707.931a2.725 2.725 0 0 1-3.393-.652v0a2.708 2.708 0 0 0-3.99-.188v0a2.7 2.7 0 0 1-3.82 0v0a2.708 2.708 0 0 0-3.99.188v0a2.725 2.725 0 0 1-3.393.652L1 17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8v13a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V8m-8.402-5.5L9.4 5.5m.002-3 5.197 3M12 1v6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdPlungeInactive);
export default __webpack_public_path__ + "static/media/cold-plunge-inactive.97b83b23c8651fc8690e2f942afaf52d.svg";
export { ForwardRef as ReactComponent };